// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2flNj{padding-top:10px}.yXAlu{height:130px;overflow-y:auto;padding-left:20px;padding-right:20px}._2CKYM{padding:0 10px;max-width:175px;vertical-align:top}._3Z4g9{color:#777}._3Z4g9:hover{color:#000}.y5zpC{margin-bottom:0}", ""]);
// Exports
exports.locals = {
	"root": "_2flNj",
	"multi": "yXAlu",
	"genecard": "_2CKYM",
	"button": "_3Z4g9",
	"gene": "y5zpC"
};
module.exports = exports;
